module.exports = __webpack_public_path__ + "static/media/girl_and_desk.8c986d42.png";